<template>

  <v-container id="body-container-card-fvl">
    <BreadCrumbs :items="itemsBreadCrumbs" />
    <LoaderLinear />
    <div id="fvl-container-card-table">
      
    <v-card elevation="0" class="fvl-card-searcher-table">
        <div class="d-flex justify-center">
        <v-text-field
          v-model="search"
          class="mb-6 searcher-input-fvl elevation-1"
          label="Buscador de etapas"
          append-icon="search"
          dense
          filled
          hide-details
        ></v-text-field>
        </div>

      <v-data-table
        :headers="dataTableheaders"
        :items="steps.steps"
        :search="search"
        class="pl-3 pr-4"
      >
        <template v-slot:[`item.is_default`]="{ item }">
          {{ item.is_default == 1 ? "Sí" : "No" }}
        </template>
        <template v-slot:[`item.is_public_by_default`]="{ item }">
          {{ item.is_public_by_default == 1 ? "Pública" : "Privada" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            v-if="
              user.permissions.indexOf(permissionsAll.step_update) >= 0 ||
                user.person.types_person.id === 3
            "
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(item)"
            v-if="
              user.permissions.indexOf(permissionsAll.step_delete) >= 0 ||
                user.person.types_person.id === 3
            "
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
     
    </v-card>
    </div>
    <SnackBar />
    <ButtonAdd
      :link="linkAdd"
      v-if="
        user.permissions.indexOf(permissionsAll.step_create) >= 0 ||
          user.person.types_person.id === 3
      "
    />
    <DialogConfirm @action="deleteStep" />
    <Overlay />
  </v-container>
  
</template>

<script>
import router from "../../router";
import {
  links,
  itemsBreadCrumbs,
  beginRequest,
  endRequest,
} from "../../helpers";
import {
  LoaderLinear,
  SnackBar,
  Overlay,
  DialogConfirm,
  BreadCrumbs,
  ButtonAdd,
} from "../_commons";
import permissions from "../../helpers/permissions";
import { mapState } from "vuex";
export default {
  name: "CardSteps",
  components: {
    BreadCrumbs,
    ButtonAdd,
    LoaderLinear,
    DialogConfirm,
    SnackBar,
    Overlay,
  },
  data() {
    return {
      linkAdd: links.step.create,
      itemsBreadCrumbs: itemsBreadCrumbs.stepList,
      search: "",
      dataTableheaders: [
        { text: "id", value: "id", class:"file-name-table"},
        {
          text: "Nombre",
          align: "start",
          value: "name",
          class:"file-name-table",
        },
        {
          text: "Descripción",
          align: "start",
          value: "description",
          class:"file-name-table",
          width: 400,
        },
        { text: "Pred.", value: "is_default", class:"file-name-table"},
        { text: "Alcance", value: "is_public_by_default", class:"file-name-table" },
        { text: "Acciones", value: "actions", class:"file-name-table", sortable: false },
      ],
      permissionsAll: permissions,
    };
  },
  methods: {
    async editItem(item) {
      await this.$store.dispatch("setStepSelectedAction", null);
      router.push(`${links.step.update}/${item.id}`);
    },
    async deleteItem(item) {
      const msg = `¿Esta seguro que desea eliminar la etapa "${item.name}"?`;
      await this.$store.dispatch("setIdItemDialogAction", item.id);
      await this.$store.dispatch("setMsgDialogConfirmAction", msg);
      await this.$store.dispatch("setDialogShowAction");
    },
    async deleteStep() {
      await beginRequest();
      await this.$store.dispatch("setDialogShowAction");
      const { status, snack } = await this.$store.dispatch(
        "deleteStep",
        this.ui.idItemDialog
      );
      await endRequest(snack, status);
    },
  },
  computed: {
    ...mapState({
      steps: (state) => state.steps,
      ui: (state) => state.ui,
      user: (state) => state.user,
    }),
  },
  async created() {
    await beginRequest();
    const { status, snack } = await this.$store.dispatch("getSteps");
    await endRequest(snack, status);
  },
};
</script>

<style></style>
